<script setup lang="ts">
import { RouterView } from 'vue-router'
import NetworkStatusBanner from '@/components/display/NetworkStatusBanner.vue'
import ToastContainer from '@/components/display/ToastContainer.vue'
import ConfirmHost from '@/components/display/ConfirmHost.vue'
</script>

<template>
  <RouterView />
  <NetworkStatusBanner />
  <ToastContainer />
  <ConfirmHost />
</template>
